import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-coche-modal',
  templateUrl: './coche-modal.component.html',
  styleUrls: ['./coche-modal.component.css']
})
export class CocheModalComponent implements OnInit {
  vehiculo: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.vehiculo = this.data;
  }

}
